export default function Maintenance() {
  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="font-heading text-6xl md:text-8xl text-text-primary mb-4">
          ROCK<span className="text-accent-red">N</span>RHEIN
        </h1>
        <p className="font-heading text-2xl text-accent-red mb-6">BALD SIND WIR ZURÜCK</p>
        <p className="font-body text-text-muted">Wir arbeiten gerade an etwas Neuem. Schau bald wieder vorbei!</p>
      </div>
    </div>
  );
}
